import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MvRouteGuardService } from 'src/app/core/services/msal/guards/mv-route-guard.service';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { LandingPageComponent } from './landing-page.component';
const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent,
    canActivate: [MvRouteGuardService],
    children: [
      {
        path: '',
        component: DashboardComponent,
        data: {title: 'EV Config - Home'},
        canActivate: [MvRouteGuardService]
      },
    ]
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],

  exports: [RouterModule]
})
export class  LandingPageRoutes{}
